import { useCallback } from "react"
import { graphql, useMutation, UseMutationConfig } from "react-relay"
import { useDeDeleteTherapyPrescriptionMutation as useDeDeleteTherapyPrescriptionMutationType } from "@/modules/patients/detail/therapy-prescription/de/services/__generated__/useDeDeleteTherapyPrescriptionMutation.graphql"

const mutation = graphql`
  mutation useDeDeleteTherapyPrescriptionMutation($input: De_deleteTherapyPrescriptionInput!) {
    de_deleteTherapyPrescription(input: $input) {
      de_TherapyPrescription {
        id @deleteRecord
      }
    }
  }
`

const useDeDeleteTherapyPrescriptionMutation = () => {
  const [commit, isFlight] = useMutation<useDeDeleteTherapyPrescriptionMutationType>(mutation)

  const commitHandler = useCallback(
    (config: UseMutationConfig<useDeDeleteTherapyPrescriptionMutationType>) => {
      commit(config)
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeDeleteTherapyPrescriptionMutation }
